import type { PageContext } from 'vike/types';
import { parsePayRoutePath } from '../../../../utils/plus-job/pay-route';

/**
 * `/job/{id}/pay` (pay comparison + past listings) and `/job/{id}/pay/{archiveId}` (one archived
 * ad). Wins over the job detail route, which would read "pay" as a company id.
 */
export function route(pageContext: PageContext) {
  const path = (pageContext as { urlLogical?: string; urlPathname?: string }).urlLogical ?? pageContext.urlPathname;
  const params = parsePayRoutePath(path);
  if (!params) return false;
  return { routeParams: { jobId: params.jobId, archiveId: params.archiveId ?? '' }, precedence: 10 };
}
